export { default } from './Form.vue';
